import { render, staticRenderFns } from "./ModalDocumentTypeNew.vue?vue&type=template&id=6759a6fc&"
import script from "./ModalDocumentTypeNew.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports